import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, Optional, SkipSelf, ErrorHandler } from '@angular/core';
import {
    HttpClientModule,
    HttpClient,
    HTTP_INTERCEPTORS
} from '@angular/common/http';
import {
    StoreRouterConnectingModule,
    RouterStateSerializer
} from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../environments/environment';

import {
    AppState,
    reducers,
    metaReducers,
    selectRouterState
} from './core.state';

import { TitleService } from './services/title.service';
import { LgvAuth0Service } from './services/lgv-auth0.service';
import { LgvSettingsService } from './services/lgv-settings.service';
import { LgvAuth0Guard } from './guards/lgv-auth0.guard';
import { LgvAPIService } from './services/lgv-api.service';
//import { LgvPhoneNumberPipe } from './pipes/phone-number.pipe';
import { LgvGlossaryService } from './services/lgv-glossary.service';
import { LgvUserService } from './services/lgv-user.service';

import {
    ROUTE_ANIMATIONS_ELEMENTS,
    routeAnimations
} from './animations/route.animations';
import { AnimationsService } from './animations/animations.service';
import { AppErrorHandler } from './error-handler/app-error-handler.service';
import { CustomSerializer } from './router/custom-serializer';
import { LgvHttpInterceptor } from './http-interceptors/lgv.http.interceptor';
import { NotificationService } from './notifications/notification.service';
import { SettingsEffects } from './settings/settings.effects';
import { selectEffectiveTheme } from './settings/settings.selectors';

import { LgvConstants } from './utility/lgv-constants';
import { LgvTSHelper } from './utility/ts-helper';
import { LgvSnapshotHelper } from './utility/lgv-snapshot-helper';
import { LgvModuleItem, LgvNavItem, LgvModuleService } from './services/lgv-module.service';
import { LgvClientAuthService } from './services/lgv-client-auth.service';
import { LgvClientService } from './services/lgv-client.service';
import { LgvUTCDatePipe } from './pipes/utc-date.pipe';
import { LgvPublicRecordHelper } from './utility/lgv-public-record-helper';
import { LgvStateService } from './state/lgv-state.service';
import { LgvPhoneNumberPipe } from './pipes/phone-number.pipe';
import { SortByPipe } from './pipes/sortby.pipe';
import { LgvLocalStorageService } from './services/lgv-local-storage.service';

export {
    LgvAuth0Service,
    LgvClientAuthService,
    LgvSettingsService,
    LgvAuth0Guard,
    LgvAPIService,
    LgvClientService,
    LgvGlossaryService,
    LgvUserService,
    LgvConstants,
    LgvTSHelper,
    LgvPublicRecordHelper,
    LgvModuleItem,
    LgvNavItem,
    LgvModuleService,
    LgvSnapshotHelper,
    LgvPhoneNumberPipe,
    SortByPipe,
    LgvUTCDatePipe,
    TitleService,
    routeAnimations,
    AppState,
    LgvLocalStorageService,
    //selectIsAuthenticated,
    ROUTE_ANIMATIONS_ELEMENTS,
    AnimationsService,
    NotificationService,
    selectEffectiveTheme,
    LgvStateService,
};

@NgModule({
    imports: [
        // angular
        CommonModule,
        HttpClientModule,

        // ngrx
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreRouterConnectingModule.forRoot(),
        EffectsModule.forRoot([
            //AuthEffects,
            SettingsEffects
        ]),

        //environment.production
        //    ? []
        //    : StoreDevtoolsModule.instrument({
        //        name: 'Angular NgRx Material Starter'
        //    }),

        // 3rd party
        //TranslateModule.forRoot({
        //    loader: {
        //        provide: TranslateLoader,
        //        useFactory: HttpLoaderFactory,
        //        deps: [HttpClient]
        //    }
        //}),

        NgbModule
    ],
    declarations: [

  ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: LgvHttpInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: RouterStateSerializer, useClass: CustomSerializer },
        DatePipe
    ],
    exports: [TranslateModule]
})
export class CoreModule {
    constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import only in AppModule');
        }
    }
}
